export class GrupoSistemaChamado {
  id:number;

  constructor(id:number) {
    this.id = id;
  }

}
